import { TwoFactorAuthType } from '@libs/types';

export const TWO_FA_TITLE_KEYS = {
  [TwoFactorAuthType.EMAIL]: 'common_email_2fa',
  [TwoFactorAuthType.SMS]: 'common_sms_2fa',
  [TwoFactorAuthType.GOOGLE]: 'common_google_2fa',
};
